const SEX_OPTIONS = {
  F: { key: 'F', name: 'Feminino' },
  M: { key: 'M', name: 'Masculino' },
  O: { key: 'O', name: 'Outro' },
};

export default SEX_OPTIONS;
